module.exports = __webpack_public_path__ + "static/media/subscription.0235e3d5.svg";